export default () => {
  const $q = useQuasar()
  return {
    error: (message: string) => $q.notify({
      message,
      color: 'negative',
    }),
    success: (message: string) => $q.notify({
      message,
      color: 'positive',
    }),
  }
}
